<div class="pcheck-card">
  <div class="pcheck-card__header pcheck-card__header--danger">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <span>Cancel Meeting — {{ details.executive }}</span>
  </div>
  <div class="pcheck-card__body">

    @if (showTzPicker) {
      <div class="pcheck-card__tz">
        <span class="pcheck-card__tz-label">Times in</span>
        <app-timezone-select [value]="displayTz()" [compact]="true" (valueChange)="onTimezoneChange($event)"></app-timezone-select>
      </div>
    }

    <app-meeting-detail-table
      [accountName]="details.account_name"
      [executive]="details.executive"
      [subject]="details.subject"
      [startTime]="details.start_time"
      [displayTimezone]="displayTz()"
      [attendeeEmail]="details.attendee_email"
      [additionalGuests]="details.additional_guests">
    </app-meeting-detail-table>

    @if (confirmed) {
      <div class="pcheck-card__confirmed">
        <i class="pi pi-check-circle" aria-hidden="true"></i> Meeting cancelled
      </div>
    } @else if (!dismissed) {

      <div class="pcheck-card__warning">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        Cancelling is permanent and will notify all attendees via Chili Piper.
      </div>

      <label class="cancel-card__field-label" for="cancel-reason">
        Reason for cancelling <span aria-hidden="true">*</span>
      </label>
      <textarea
        id="cancel-reason"
        class="cancel-card__reason"
        rows="2"
        maxlength="500"
        placeholder="Briefly: why are you cancelling? (required)"
        [value]="reason()"
        (input)="onReasonInput($event)"
        aria-required="true">
      </textarea>

      <label class="cancel-card__field-label" for="cancel-typed">
        Type <strong>CANCEL</strong> to enable the button
      </label>
      <input
        id="cancel-typed"
        type="text"
        class="cancel-card__typed"
        placeholder="CANCEL"
        autocomplete="off"
        spellcheck="false"
        [value]="typedPhrase()"
        (input)="onTypedInput($event)"
        aria-label="Type CANCEL to enable the destructive button" />

      <div class="pcheck-card__actions">
        <button type="button" class="pcheck-btn pcheck-btn--neutral" (click)="onDismiss()">
          <i class="pi pi-times" aria-hidden="true"></i> Keep Meeting
        </button>
        <button type="button" class="pcheck-btn pcheck-btn--danger"
          [disabled]="!canSubmit" (click)="onConfirm()">
          <i class="pi pi-trash" aria-hidden="true"></i> Confirm Cancel
        </button>
      </div>

    }

  </div>
</div>
